/**
 * Accueil : produit phare (sections/cg-home-pack.liquid).
 * <cg-pack-buy> : bascule abonnement / achat unique. Le select `selling_plan` (rattaché au
 * formulaire produit par l'attribut form) n'est actif qu'en abonnement, pour que
 * product-form-component n'envoie le plan que dans ce cas. Met à jour le prix du bouton.
 */
class CgPackBuy extends HTMLElement {
  connectedCallback() {
    this.options = [...this.querySelectorAll('[data-cg-pack-option]')];
    if (!this.options.length) return;

    this.plan = this.querySelector('[data-cg-pack-plan]');
    this.ctaPrice = this.querySelector('[data-cg-pack-cta-price]');
    this.subPrice = this.querySelector('[data-cg-pack-sub-price]');

    this.addEventListener('change', (event) => {
      const target = event.target;
      if (target.matches('input[type="radio"]')) this.update();
      if (target === this.plan) this.update();
    });

    this.update();
  }

  update() {
    let mode = 'onetime';

    this.options.forEach((option) => {
      const radio = option.querySelector('input[type="radio"]');
      const selected = Boolean(radio?.checked);
      option.classList.toggle('is-selected', selected);
      if (selected) mode = option.dataset.cgPackOption;
    });

    if (this.plan) this.plan.disabled = mode !== 'subscription';

    let price = this.querySelector(`[data-cg-pack-option="${mode}"]`)?.dataset.price;
    if (mode === 'subscription' && this.plan) {
      const planPrice = this.plan.selectedOptions[0]?.dataset.price;
      if (planPrice) {
        price = planPrice;
        if (this.subPrice) this.subPrice.textContent = planPrice;
      }
    }

    if (this.ctaPrice && price) this.ctaPrice.textContent = price;
  }
}

if (!customElements.get('cg-pack-buy')) customElements.define('cg-pack-buy', CgPackBuy);
